import gql from "graphql-tag";
import { ITopic } from "@/models/Topic.model";

export const allTopics = () => {
  return gql`
    query allTopics($conference: ID!) {
      allTopics(conference: $conference) {
        _id
        title
        link
        description
      }
    }
  `;
};

export const insertTopic = (topic: ITopic) => {
  return gql`mutation {insertTopic( conference:"${topic.conference}",
    title:"${topic.title}",
    link:"${topic.link}",
    description:"${topic.description}"){
    ${`
    conference
    title
    link
    description
    `}
  }}`;
};

export const deleteTopic = (title: string, conference: string) => {
  return gql`mutation {deleteTopic( conference:"${conference}",
  title:"${title}"
  ){
    ${`
    conference
    title
    link
    description
    `}
  }}`;
};
